<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
    <document-type-list-filter
      @edit="editComponentFilters($event, 'filter__document_type__in')"
      @clean="cleanComponentFilters(['filter__document_type__in'])"
    />
    <checklist-list-filter
      :title="$t('Filter by presence in checklist')"
      @edit="editComponentFilters($event, 'filter__in_yard_check_list')"
      @clean="cleanComponentFilters(['filter__in_yard_check_list'])"
    />
    <customer-reminder-list-filter
      :title="$t('Filter by customer reminder')"
      @edit="editComponentFilters($event, 'filter__in_customer_reminder')"
      @clean="cleanComponentFilters(['filter__in_customer_reminder'])"
    />
    <download-for-external-list-filter
      :title="$t('Filter documents downloadable by externals')"
      @edit="editComponentFilters($event, 'filter__download_for_external')"
      @clean="cleanComponentFilters(['filter__download_for_external'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as DOCUMENT_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'DocumentCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: DOCUMENT_TYPES.GENERIC.document.document.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...DOCUMENT_TYPES.GENERIC.document.document.LIST.ACTIONS
    })
  }
}
</script>
